import formInputCommonOptions from '../../../../../../../Frontend/src/foundation/js/utils/forms/formInputCommonOptions.js'

const options = formInputCommonOptions('FormRadioGroupInput', {
    validatorFunction(input) {
        return input
    },
})

export default options
